module.exports = __webpack_public_path__ + "static/media/stat-descargas.2ce62b7e.png";